import React from 'react';

import NotFound from '@components/NotFound';
import PageLoader from '@components/PageLoader';

import { RoleName } from '@constants/role_name';

import { useSession } from '@hooks/useSession';

type RoleGuardProps = React.PropsWithChildren<{
  roles: RoleName[];
}>;

const RoleGuard: React.FC<RoleGuardProps> = ({
  children = null,
  roles = [],
}) => {
  const {
    state: {
      isAdmin,
      isClient,
      isCurator,
      isPatient,
      isCuratorAdmin,
      isPractitioner,
      isLoadingAuth,
      isAuthenticated,
    },
  } = useSession();

  const ROLE_MAP: Record<string, boolean> = {
    [RoleName.Admin]: isAdmin,
    [RoleName.CuratorAdmin]: isCuratorAdmin,
    [RoleName.Client]: isClient,
    [RoleName.Curator]: isCurator,
    [RoleName.Patient]: isPatient,
    [RoleName.Practitioner]: isPractitioner,
    [RoleName.SysAdmin]: isAdmin,
  };

  if (isLoadingAuth || !isAuthenticated) {
    return <PageLoader />;
  }

  if (!roles.find((role) => ROLE_MAP[role])) {
    return <NotFound />;
  }

  return <>{children}</>;
};

export default RoleGuard;
